const font_families = {
  roost: "Roboto",
};


export default font_families;